import { render, staticRenderFns } from "./rebootSlightRobotTable.vue?vue&type=template&id=486e162d&scoped=true&"
import script from "./rebootSlightRobotTable.vue?vue&type=script&lang=js&"
export * from "./rebootSlightRobotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e162d",
  null
  
)

export default component.exports